import React, { useState } from "react";
import { useJourney } from "./JourneyProvider";
import { useNavigate, useParams } from "react-router-dom";
import {
  invalidateDevice,
  sendSerasaCadastralAuthenticationFromStates,
  sendSerasaFaceMatchFromStates,
  sendSerasaDocumentoscopyFromStates,
  sendSerproFaceBureauFromStates,
} from "../../services/allowService";

type Props = {
  onDone?: () => void;
};

const FinishScreen: React.FC<Props> = ({ onDone }) => {
  const { styles, journey, setJourney, documentImage, selfieImage, cpf, ip } =
    useJourney();
  const navigate = useNavigate();
  const { token } = useParams<{ token: string }>();
  const [isLoading, setIsLoading] = useState(false);

  const isStepEnabled = (id: string) =>
    journey?.screens?.some((s: any) => s.id?.toLowerCase() === id.toLowerCase() && s.enabled);

  const handleDone = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {

      if (token) {
        await invalidateDevice(token, journey?.protocol || "");
      }

      if (
        documentImage &&
        selfieImage &&
        journey?.screens?.some((s: any) => s.id === "facematch" && s.enabled)
      ) {
        await sendSerasaFaceMatchFromStates(documentImage, selfieImage, journey.protocol, cpf);
      }

      if (
        documentImage &&
        journey?.screens?.some((s: any) => s.id === "documentoscopia" && s.enabled)
      ) {
        await sendSerasaDocumentoscopyFromStates(documentImage, journey?.protocol, cpf);
      }

      if (selfieImage && journey?.screens?.some((s: any) => s.id?.toLowerCase() === "bureau" && s.enabled)) {
        const bureau = journey?.screens?.find((s: any) => (s.id || "").toLowerCase() === "bureau");
        const provider = String((bureau?.Provider ?? bureau?.provider) ?? "").toLowerCase();

        if (provider === "serpro") {
          await sendSerproFaceBureauFromStates(selfieImage, journey!.protocol, cpf);
        } else {
          await sendSerasaCadastralAuthenticationFromStates(selfieImage, journey!.protocol, cpf);
        }
      }

      await Promise.resolve(onDone?.());

      const url = styles?.redirectLink?.trim();
      if (!url) return;

      if (url.startsWith("/")) navigate(url);
      else window.location.assign(url);

      setJourney(undefined);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 15,
        height: "100%",
        justifyContent: "center",
      }}
    >
      {styles.finalText ||
        " Obrigado por concluir o processo de validação de identidade! Agora é com a gente! Em breve você receberá a atualização do seu status."}

      {journey && (
        <button
          onClick={handleDone}
          disabled={isLoading}
          style={{
            width: "100%",
            padding: "12px 0",
            backgroundColor: styles.buttonColor,
            border: "none",
            borderRadius: 6,
            color: styles.buttonLabelColor,
            fontWeight: 600,
            fontSize: 16,
            cursor: isLoading ? "default" : "pointer",
            opacity: isLoading ? 0.7 : 1,
            transition: "opacity 0.2s ease",
          }}
        >
          {isLoading ? "Processando..." : "Concluir"}
        </button>
      )}
    </div>
  );
};

export default FinishScreen;
